<app-search #appSearch (cleared)="clearSearch()" (enterPressed)="handleEnter()"></app-search>

